import React, { useState, useEffect } from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import { SelectedSurvey } from "../../../utils/globalState";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { getSurveyActionsById } from "../../../services/PharmacyUser";
const ActionsHistory = () => {
  const survey = SelectedSurvey.getState().ThisSurvey;
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (survey.id) {
      getSurveyActionsById(survey.id).then((res) => {
        setRows(res.data);
      });
    }
  }, [survey]);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "actionDate", headerName: "Action Date", width: 180 },
    { field: "actionType", headerName: "Action Type", width: 130 },
    { field: "actionUser", headerName: "Action User ID", width: 120 },
    { field: "surveyId", headerName: "Survey ID", width: 100 },
    { field: "actionDetails", headerName: "Action Details", width: 200 },
    { field: "firstName", headerName: "First Name", width: 130 },
    { field: "lastName", headerName: "Last Name", width: 130 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "phone", headerName: "Phone", width: 150 },
    { field: "type", headerName: "User Type", width: 150 },
    {
      field: "active",
      headerName: "Active Status",
      width: 120,
      type: "boolean",
    },
  ];

  const paginationModel = { page: 0, pageSize: 50 };

  return (
    <div className="container-fluid">
      <DialogTitle id="alert-dialog-title">
        History of {survey.json.title} survey.
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{ pagination: { paginationModel } }}
            pageSizeOptions={[5, 10, 25, 50, 100]}
            checkboxSelection
            sx={{ border: 0, height: "100%", width: "100%" }}
            slots={{ toolbar: GridToolbar }}
          />
        </DialogContentText>
      </DialogContent>
    </div>
  );
};

export default ActionsHistory;
